import type { QueryClient } from "@tanstack/react-query"

const HOME_ACTIVATION_QUERY_KEY_PREFIX = [
  "transport",
  "homeActivation",
] as const

export async function invalidateHomeQueries(queryClient: QueryClient) {
  await queryClient.invalidateQueries({
    queryKey: HOME_ACTIVATION_QUERY_KEY_PREFIX,
  })
}
